// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader@6.11.0_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader@6.11.0_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes spinner-line-fade-more {
  0%, 100% {
    opacity: 0; /* minimum opacity */
  }
  1% {
    opacity: 1;
  }
}

@keyframes spinner-line-fade-quick {
  0%, 39%, 100% {
    opacity: 0.25; /* minimum opacity */
  }
  40% {
    opacity: 1;
  }
}

@keyframes spinner-line-fade-default {
  0%, 100% {
    opacity: 0.22; /* minimum opacity */
  }
  1% {
    opacity: 1;
  }
}

@keyframes spinner-line-shrink {
  0%, 25%, 100% {
    /* minimum scale and opacity */
    transform: scale(0.5);
    opacity: 0.25;
  }
  26% {
    transform: scale(1);
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./node_modules/.pnpm/spin.js@4.1.1/node_modules/spin.js/spin.css"],"names":[],"mappings":"AAAA;EACE;IACE,UAAU,EAAE,oBAAoB;EAClC;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,aAAa,EAAE,oBAAoB;EACrC;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,aAAa,EAAE,oBAAoB;EACrC;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,8BAA8B;IAC9B,qBAAqB;IACrB,aAAa;EACf;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF","sourcesContent":["@keyframes spinner-line-fade-more {\r\n  0%, 100% {\r\n    opacity: 0; /* minimum opacity */\r\n  }\r\n  1% {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@keyframes spinner-line-fade-quick {\r\n  0%, 39%, 100% {\r\n    opacity: 0.25; /* minimum opacity */\r\n  }\r\n  40% {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@keyframes spinner-line-fade-default {\r\n  0%, 100% {\r\n    opacity: 0.22; /* minimum opacity */\r\n  }\r\n  1% {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@keyframes spinner-line-shrink {\r\n  0%, 25%, 100% {\r\n    /* minimum scale and opacity */\r\n    transform: scale(0.5);\r\n    opacity: 0.25;\r\n  }\r\n  26% {\r\n    transform: scale(1);\r\n    opacity: 1;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
